import PropTypes from 'prop-types'

export const cardProps = {
  name: PropTypes.string.isRequired,
  onlyBack: PropTypes.bool,
  onlyFront: PropTypes.bool,
  reverse: PropTypes.bool,
  sideBySide: PropTypes.bool,
  tag: PropTypes.string,
}
